import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import { Toaster } from './components/ui/sonner';
import AppShell from './components/app/AppShell';
import AuthPage from './pages/AuthPage';
import FeedPage from './pages/FeedPage';
import ReelsPage from './pages/ReelsPage';
import MessagesPage from './pages/MessagesPage';
import AIHubPage from './pages/AIHubPage';
import ExercisesPage from './pages/ExercisesPage';
import ChallengesPage from './pages/ChallengesPage';
import LeaderboardPage from './pages/LeaderboardPage';
import ProfilePage from './pages/ProfilePage';
import SettingsPage from './pages/SettingsPage';
import AdminPage from './pages/AdminPage';
import DiscoverPage from './pages/DiscoverPage';

function Protected({ children, requiredRole }) {
  const { user, loading } = useApp();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-10 h-10 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  if (requiredRole && user.role !== requiredRole) return <Navigate to="/" replace />;
  return <AppShell>{children}</AppShell>;
}

function AuthOnly() {
  const { user, loading } = useApp();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-10 h-10 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  return user ? <Navigate to="/" replace /> : <AuthPage />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/auth" element={<AuthOnly />} />
      <Route path="/" element={<Protected><FeedPage /></Protected>} />
      <Route path="/reels" element={<Protected><ReelsPage /></Protected>} />
      <Route path="/discover" element={<Protected><DiscoverPage /></Protected>} />
      <Route path="/messages" element={<Protected><MessagesPage /></Protected>} />
      <Route path="/messages/:userId" element={<Protected><MessagesPage /></Protected>} />
      <Route path="/ai" element={<Protected><AIHubPage /></Protected>} />
      <Route path="/exercises" element={<Protected><ExercisesPage /></Protected>} />
      <Route path="/challenges" element={<Protected><ChallengesPage /></Protected>} />
      <Route path="/leaderboard" element={<Protected><LeaderboardPage /></Protected>} />
      <Route path="/profile/:userId" element={<Protected><ProfilePage /></Protected>} />
      <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
      <Route path="/admin" element={<Protected requiredRole="admin"><AdminPage /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
